import { BatchModel } from './BatchModel';
import { ExpositionBatchDto } from './ExpositionBatchDto';

export interface ExpositionBatchModel {
    classificationsId: number[],
    expositions: BatchModel[],
    expositionsDto: ExpositionBatchDto[]
}

export const expositionBatchModelInitial: ExpositionBatchModel = {
    classificationsId: [],
    expositions: [],
    expositionsDto: [],
};